import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { 
    Flex, Box, Link, Heading, FormControl, FormLabel, Input, Button, ButtonGroup, Text, CircularProgress,
    InputGroup, InputRightElement, Icon, IconButton,
    Stack, HStack, Menu, MenuButton, MenuList, MenuItem
} from '@chakra-ui/react';
import { MdLogin, MdLogout, MdGroup, MdPortrait, MdClose } from 'react-icons/md';
import { FaStore, FaWarehouse, FaHammer, FaRegFile, FaUser, FaBars } from 'react-icons/fa';
import { BiImport, BiExport } from 'react-icons/bi';
import { BsPersonSquare } from 'react-icons/bs';
import { ChevronDownIcon } from '@chakra-ui/icons';

function Navbar() {
    const [ cookies, setCookie, removeCookie ] = useCookies(["loginCookie", "selectedClinic"]);
    const navigate = useNavigate();
    const [ isShow, setIsShow ] = useState(false);
    const { pathname } = useLocation();

    return (
        <Box mb={{ base: 4, md: 0, lg: 0 }}>
            <Flex justify="flex-start" position="fixed" left={0} top={0}
                display={{ base: isShow ? "none" : "inherit", md: "none", lg: "none" }}
            >
                <IconButton variant="ghost" _hover="transparent" icon={<FaBars />} 
                    onClick={() => {
                        setIsShow(!isShow)
                    }}
                />
            </Flex>
            <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} w="100%" bg="gray.700" p={2} 
                alignItems={{ base: "flex-start", md: "center", lg: "center" }} justify={{ base: "flex-end", md: "space-between", lg: "space-between" }}
                display={{ base: isShow ? "flex" : "none", md: "flex", lg: "flex" }} gap={1}
            >
                {/* <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} w="100%" gap={{ base: 1, md: 6, lg: 6 }}>
                    <Flex justify="space-between" align="center">
                        <Link href='/' color="greenyellow" fontSize="20px" fontWeight="700" mr={8} _hover={{ textDecor: "none" }}>
                            {cookies.loginCookie.isSuperAdmin ? "ADMIN" : cookies.loginCookie?.companyDetail?.name}
                        </Link>
                        <IconButton variant="ghost" _hover="transparent" color="white" icon={<MdClose />} 
                            display={{ base: (isShow ? "inherit" : "inherit"), md: "none", lg: "none" }}
                            onClick={() => {
                                setIsShow(!isShow)
                            }}
                        />
                    </Flex>
                    {
                        cookies.loginCookie.isSuperAdmin &&
                        <Link href='/companies' color={(pathname === "/companies") ? "teal.400" : "#ffffff"} display="flex" gap={1} alignItems="center" justifyItems="center">
                            <Icon as={FaStore}/><Text fontWeight="semibold" textTransform="uppercase">Cửa hàng</Text>
                        </Link>
                    }

                    {
                        !cookies.loginCookie.isSuperAdmin &&
                        <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} align={{ base: "flex-start", md: "center", lg: "center" }}
                            gap={{ base: 0, md: 4, lg: 4 }}
                        >
                            <Link href='/warehouses' color={(pathname === "/warehouses") ? "teal.400" : "#ffffff"} display="flex" gap={1} alignItems="center" justifyItems="center"
                                _hover={{ textDecor: "none" }}
                            >
                                <Icon as={FaWarehouse}/><Text fontWeight="semibold" textTransform="uppercase">kho</Text>
                            </Link>
                            <Link href='/items' color={(pathname === "/items") ? "teal.400" : "#ffffff"} display="flex" gap={1} alignItems="center" justifyItems="center"
                                _hover={{ textDecor: "none" }}
                            >
                                <Icon as={FaHammer}/><Text fontWeight="semibold" textTransform="uppercase">vật tư</Text>
                            </Link>
                            <Menu>
                                <MenuButton w="fit-content" pl={{ base: 0 }} backgroundColor="transparent" as={Button} color={(pathname === "/imports" || pathname === "/exports") ? "teal.400" : "#ffffff"} 
                                    rightIcon={<ChevronDownIcon />} _hover={{ backgroundColor: "transparent" }} _active={{ backgroundColor: "transparent" }}
                                >
                                    <Flex gap={1} alignItems="center" justifyItems="center">
                                        <Icon as={FaRegFile}/>
                                        <Text fontWeight="semibold" textTransform="uppercase">
                                            { (pathname === "/imports") ? "phiếu nhập" : ((pathname === "/exports") ? "phiếu xuất" : "phiếu") }
                                        </Text>
                                    </Flex>
                                </MenuButton>
                                <MenuList>
                                    <MenuItem as="a" gap={1} href='/imports'>
                                        <Icon boxSize={6} as={BiImport}/>
                                        <Text fontWeight="semibold" textTransform="uppercase">phiếu nhập</Text>
                                    </MenuItem>
                                    <MenuItem as="a" gap={1} href='/exports'>
                                        <Icon boxSize={6} as={BiExport}/>
                                        <Text fontWeight="semibold" textTransform="uppercase">phiếu xuất</Text>
                                    </MenuItem>
                                </MenuList>
                            </Menu>
                            <Link href='/customers' color={(pathname === "/customers") ? "teal.400" : "#ffffff"} display="flex" gap={1} alignItems="center" justifyItems="center"
                                _hover={{ textDecor: "none" }}
                            >
                                <Icon as={BsPersonSquare}/><Text fontWeight="semibold" textTransform="uppercase">khách hàng</Text>
                            </Link>
                        </Flex>
                    }
                    <Link href='/users' color={(pathname === "/users") ? "teal.400" : "#ffffff"} display="flex" gap={1} alignItems="center" justifyItems="center"
                        _hover={{ textDecor: "none" }}
                    >
                        <Icon as={FaUser}/><Text fontWeight="semibold" textTransform="uppercase">Tài khoản</Text>
                    </Link>
                </Flex> */}

                <Flex w="100%" flexDirection="row" justify="space-between">
                    <Heading size="md" color="#ffffff">CHẠM TOOLS</Heading>
                    <Button colorScheme="red"
                        onClick={ () => {
                            removeCookie("loginCookie", { path: "/" });
                            navigate("/login");
                        }}
                    >
                        <Icon boxSize={6} as={MdLogout} marginRight="8px"/>Đăng xuất
                    </Button>
                    {/* <Menu>
                        <MenuButton as={Button} rightIcon={<ChevronDownIcon />}>
                            <HStack>
                                <Text fontWeight="400">
                                    Chạm kem bơ
                                </Text>
                            </HStack>
                        </MenuButton>
                        <MenuList>
                            <MenuItem as="a" color="red.500" onClick={ 
                                    () => {
                                        removeCookie("loginCookie", { path: "/" });
                                        navigate("/login");
                                    }
                                }
                            >
                                <Icon boxSize={6} as={MdLogout} marginRight="8px"/>Đăng xuất
                            </MenuItem>
                        </MenuList>
                    </Menu> */}
                </Flex>
            </Flex>
        </Box>
    )
}

export default Navbar;